<template>
	<div v-loading="loading" class="modal-tag-users modal-wrapper user-tagging">
		<div class="user-tagging-drawer">
			<div class="flex items-center justify-between font-uppercase">
				<div class="tagging-title text-truncate">
					{{ $t('events.player.addons.userTagging.tagPeopleOnTagText', { tag: options.tag.name }) }}
				</div>
				<div class="flex user-tagging-close">
					<button class="close-btn" @click="close" />
				</div>
			</div>
			<user-tagging-list v-loading="loading" :users="users" :active-playback="activePlayback" :is-tagging-on-tag="true" @user-tag-changed="onUserTagChanged" />
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import UserTaggingList from '~/components/events/view/player-addons/user-tagging/UserTaggingList'
import { ModalMixin } from '~/assets/vue/mixins'
import analytics from '~/assets/util/analytics'
import { formatTaggedUsers } from '~/assets/util/formatters'

export default {
	name: 'ModalTagUsers',
	components: {
		UserTaggingList
	},
	mixins: [ModalMixin],
	inject: {
		activePlayback: {
			default: null
		},
		mainEvent: {
			default: null
		}
	},
	props: {
		options: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			loading: false,
			taggedUsers: [],
			users: []
		}
	},
	mounted () {
		this.getUserTag()
	},
	methods: {
		...mapActions({ analyticsTrack: 'analytics/track' }),

		async onUserTagChanged (options) {
			const body = {
				users: [
					{
						id: options.id,
						action: options.value ? 'set' : 'unset'
					}
				],
				eventId: this.activePlayback.eventId,
				target: {
					id: this.options.tag.id,
					type: 'tag'
				}
			}

			try {
				this.loading = true

				await this.$axios.$post('api/v1/users/tags', body)
				await this.getUserTag()

				this.updateUser(options.user, options.value)
				this.loading = false
			} catch (e) {
				this.$toast.error(this.$tc('errors.userTagUpdateError'))
				this.$log.error('Failed to update user tag', e)
			}
		},
		updateUser (user, value) {
			const foundUser = this.users.find(el => el.id === user.id)
			foundUser.enabled = value
		},
		close () {
			this.onConfirm(this.taggedUsers)

			this.analyticsTrack({
				event: analytics.TagMemberListClosed.event,
				data: analytics.TagMemberListClosed.getData({ activePlayback: this.activePlayback, mainEvent: this.mainEvent, isTag: true })
			})
		},
		async getUserTag () {
			try {
				this.loading = true

				const eventId = this.activePlayback.eventId
				const userTagTarget = 'tag'
				const targetId = this.options.tag.id
				const result = await this.$axios.$get(`/api/v1/users/tags/events/${eventId}/${userTagTarget}/${targetId}?limit=100`)

				if (result.data) {
					this.taggedUsers = result.data
					this.users = JSON.parse(JSON.stringify(formatTaggedUsers(this.taggedUsers, this.mainEvent?.meta?.users)))
				}
				this.loading = false
			} catch (e) {
				this.$toast.error(this.$tc('errors.fetchError'))
				this.$log.error('Failed to fetch user tags', e)
			}
		}
	}
}
</script>

<style lang="scss">
.modal-popup-wrap {
	align-items: flex-start;
	justify-content: flex-start;
}
.modal-tag-users {
	position: relative;
	align-items: flex-start;
	height: 100%;
	width: 100%;

	&.user-tagging {
		margin-right: 0;
		bottom: 0;
	}

	.user-tagging-drawer {
		min-height: 100%;
		width: 100%;
	}
}
</style>
